import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
    CREATE_JOB,
    DELETE_JOB,
    GET_ALL_JOBS,
    GET_JOB_FUNCTION,
    POST_JOB_FUNCTION,
    DELETE_JOB_FUNCTION
} from "../constants/Schedule";

import { getAllJobs, createJob, deleteJob, saveAllJobs, saveJobFunction } from "../actions/Schedule";
import { toastNotification } from "../../utils/toastNotification";
import ApiService from "../../Services/ApiService";

export function* createJobSaga() {
    yield takeEvery(CREATE_JOB, function* (action) {
        try {
            let response = yield ApiService.post("/antman/api/v1/env/leadSchedule/job/bot_identity", {}, action.payload)
            toastNotification({ res: response });
            yield put(getAllJobs());
        } catch (e) {

        }
    });
}

export function* createFunctionSaga() {
    yield takeEvery(POST_JOB_FUNCTION, function* (action) {
        // debugger;
        try {
            let response = yield ApiService.post(`/antman/api/v1/env/leadSchedule/bot_identity/${action.payload.name}`, {}, {
                code: action.payload.code,
                interval: action.payload.data.interval
            })
            
            if (response && response.status == "success") {
                yield put(createJob(action.payload.data));
            }
        } catch (e) {

        }
    });
}

export function* deleteJobSaga() {
    yield takeEvery(DELETE_JOB, function* (action) {
        try {
            let response = yield ApiService.delete(`/antman/api/v1/env/leadSchedule/job/bot_identity/${action.payload.name}`)
            toastNotification({ res: response });
            yield put(getAllJobs());
        } catch (e) {

        }
    });
}

export function* deleteFunctionSaga() {
    yield takeEvery(DELETE_JOB_FUNCTION, function* (action) {
        try {
            let response = yield ApiService.delete(`/antman/api/v1/env/leadSchedule/bot_identity/${action.payload.name}`)

            if (response && response.status == "success") {
                yield put(deleteJob(action.payload.name));
            }
        } catch (e) {

        }
    });
}

export function* getAllJobsSaga() {
    yield takeEvery(GET_ALL_JOBS, function* (action) {
        try {
            let response = yield ApiService.get(`/antman/api/v1/env/leadSchedule/job/bot_identity`)

            if (response && response.status == "success") {
                yield put(saveAllJobs(response.data));
            }
        } catch (e) {

        }
    });
}

export function* getFunctionContentSaga() {
    yield takeEvery(GET_JOB_FUNCTION, function* (action) {
        try {
            let response = yield ApiService.get(`/antman/api/v1/env/leadSchedule/bot_identity/${action.payload.name}`)

            if (response && response.status == "success") {
                yield put(saveJobFunction(response.data.data));
            }
        } catch (e) {

        }
    });
}

export default function* rootSaga() {
    yield all([
        createJobSaga(),
        getAllJobsSaga(),
        deleteFunctionSaga(),
        deleteJobSaga(),
        createFunctionSaga(),
        getFunctionContentSaga()
    ]);
}
